export default __webpack_public_path__ + "static/media/submission-by-category.3bdade91.svg";